define('js/globals/isPreview',['js/lib/queryString'], function (queryString) {
    'use strict';

    return queryString.parse().preview === 'true';
});
